import React, { Component } from "react";

import { IAnalyticsModuleParameters } from "@formant/core/model/IAnalyticsModuleParameters";

import { observeStore } from "../../stores";
import { IBaseModuleProps } from "../Observe/IBaseModuleProps";
import { GenericRowChart } from "./GenericRowChart";
import { Loading } from "./Loading";
import { NoDevices } from "./NoDevices";

interface IAnalyticsChartProps extends IBaseModuleProps {
    params: IAnalyticsModuleParameters;
}

export class AnalyticsChart extends Component<IAnalyticsChartProps> {
    public render() {
        const { props } = this;
        const { params, filter } = this.props;
        const { device } = props;
        const deviceId = device?.id;

        if (!params?.query) {
            return false;
        }

        const { query } = params;

        const start = observeStore.analyticsTempStartDate || query.start;
        const end = observeStore.analyticsTempEndDate || query.end;
        const chartType = params?.configuration?.chartType;
        query.start = start;
        query.end = end;

        if (deviceId) {
            query.deviceIds = [deviceId];
        } else if ((filter?.deviceIds || []).length > 0) {
            query.deviceIds = [...(filter.deviceIds || [])];
        } else {
            return <NoDevices />;
        }

        if (
            (query.type !== "advanced" && query.tableColumns?.length === 0) ||
            (query?.type === "advanced" && !query?.sqlQuery)
        ) {
            return (
                <Loading
                    missingYAxis={true}
                    rows={undefined}
                    columns={undefined}
                />
            );
        }

        return (
            <GenericRowChart
                key={query.deviceIds.join(".")}
                params={params}
                query={query}
                chartType={chartType}
                start={start}
                end={end}
            />
        );
    }
}
